import React from "react";
import { Button } from "antd";

type AppErrorBoundaryState = {
  hasError: boolean;
};

class AppErrorBoundary extends React.Component<
  React.PropsWithChildren,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Erro não tratado na interface", error, errorInfo);
  }

  private handleReturn = () => {
    const path = window.location.pathname;
    const destination = path.includes("colaborador")
      ? "/login-colaborador"
      : path.includes("admin")
        ? "/admin-sign-in"
        : "/";
    window.location.assign(destination);
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="px-error-page" role="alert">
        <section className="px-error-panel">
          <span className="px-error-code">Prax Pay</span>
          <h1>Não foi possível abrir esta página</h1>
          <p>Sua sessão ou os dados desta tela precisam ser carregados novamente.</p>
          <div className="px-error-actions">
            <Button type="primary" onClick={() => window.location.reload()}>
              Tentar novamente
            </Button>
            <Button onClick={this.handleReturn}>
              Voltar ao login
            </Button>
          </div>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;